import { LocationEnum } from '../enums/locations.enum';
import { Dictionary } from '../../../shared/models/dictionary';

export const getLocation = () => [
  { id: LocationEnum.WAREHOUSE, name: 'Magazyn' },
  { id: LocationEnum.SERVICE, name: 'Serwis' },
] as Dictionary[];
